import { BRAND } from '../constants/brand'
import { LOADING_LABELS } from '../constants/loading'
import { type PageLoaderProps } from '../constants/ui'
import { cx } from '../helpers/format'
import { Spinner } from './Spinner'
import '../styles/page-loader.scss'

export function PageLoader({
  label = LOADING_LABELS.page,
  variant = 'panel',
}: PageLoaderProps) {
  return (
    <div className={cx('page-loader', `page-loader--${variant}`)}>
      {variant === 'screen' ? (
        <img
          src={BRAND.logoSrc}
          alt=""
          className="page-loader__logo"
          width={BRAND.logoWidth}
          height={BRAND.logoHeight}
        />
      ) : null}
      <Spinner block label={label} />
    </div>
  )
}
